import { Link } from 'react-router-dom'

type LandingNoticesProps = {
  error: string | null
  migratedNotice: boolean
}

export function LandingNotices({ error, migratedNotice }: LandingNoticesProps) {
  if (!migratedNotice && !error) return null

  return (
    <div className="mt-8 space-y-4 max-w-md mx-auto">
      {migratedNotice && (
        <div className="bg-yellow-50 border border-yellow-200 rounded-md p-4 text-left">
          <p className="text-sm text-yellow-900 font-medium">
            このブラウザは既にアカウント登録されています
          </p>
          <p className="text-xs text-yellow-900 mt-1">
            ログインまたは別ブラウザからお試しください。
          </p>
          <Link
            to="/login"
            className="inline-block mt-2 text-sm text-yellow-900 underline font-medium"
          >
            ログインへ
          </Link>
        </div>
      )}
      {error && (
        <div className="bg-red-50 border border-red-200 rounded-md p-4 text-sm text-red-700 text-left">
          {error}
        </div>
      )}
    </div>
  )
}
